import { render, staticRenderFns } from "./MonthlyHistoryCard.vue?vue&type=template&id=823ed796&scoped=true"
import script from "./MonthlyHistoryCard.vue?vue&type=script&lang=js"
export * from "./MonthlyHistoryCard.vue?vue&type=script&lang=js"
import style0 from "./MonthlyHistoryCard.vue?vue&type=style&index=0&id=823ed796&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823ed796",
  null
  
)

export default component.exports